module.exports = __webpack_public_path__ + "static/media/08_sognolucido.9c22472b.jpg";